import React, { useState } from "react";
import { classNames } from "../../../../general/functions/propsComponent";
import { TelephoneFill } from "react-bootstrap-icons";

export default function ModalAkhiriSesi(props) {
  const { handleChoosen } = props;
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        className={classNames(
          "btn-primary bg-red-500 p-2 w-14 h-14 flex flex-col justify-center items-center whitespace-nowrap rounded-full absolute -top-1"
        )}
        onClick={() => {
          setShowModal(true);
        }}
      >
        <p className="text-sm font-semibold">
          <TelephoneFill size={24} className="rotate-[135deg] " />{" "}
        </p>
      </button>

      {showModal ? (
        <>
          <div className="backdrop-filter backdrop-blur-sm justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative mx-6 my-6 sm:mx-auto w-full max-w-lg">
              {/*content*/}
              <div className="border-t-8  rounded-md border-red-500 shadow-lg relative flex flex-col w-full bg-secondary-500 outline-none focus:outline-none ">
                {/*header*/}
                <button
                  className="absolute top-2 right-4 p-1 ml-auto bg-transparent border-0 text-black opacity-4 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={() => setShowModal(false)}
                >
                  <span className="bg-transparent text-white opacity-75 h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
                <div className="flex items-start justify-between pt-10 px-10 pb-0 ">
                  <h3 className="text-3xl font-semibold  text-red-500 ">
                    Perhatian
                  </h3>
                </div>

                {/*body*/}
                <div className="relative px-10 py-4  flex-auto ">
                  <p
                    className="
                    my-4 text-white text-lg leading-relaxed whitespace-normal"
                  >
                    Apakah Anda akan mengakhiri Panggilan Video?{" "}
                  </p>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 rounded-b gap-1">
                  <button
                    className="btn-secondary"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Batal
                  </button>
                  <button
                    className="btn-primary bg-red-500"
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      handleChoosen("LEAVE");
                    }}
                  >
                    Akhiri
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
